import React from "react";
import { AppBar, Toolbar, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import LogoHeader from "./LogoHeader";

const Navbar = () => {
  const navigate = useNavigate();

  return (
    <AppBar position="static" color="transparent" elevation={0}>
      <Toolbar>
        <Box
          onClick={() => navigate("/app")}
          sx={{
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
          }}
        >
          <LogoHeader />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
